import {useTranslation} from 'react-i18next';
import {useCurrentPatient} from '@/patient/context/CurrentPatientContext';
import {FullScreenModalTitle} from '@/shared/components/ui/Modal';

export default function ModalTitle() {
  const patient = useCurrentPatient();
  const {t} = useTranslation(['shared/common']);

  const title = t('shared/common:diagnosticReport.form.newCase', {
    fullname: patient.fullname
  });

  return <FullScreenModalTitle>{title}</FullScreenModalTitle>;
}
